import { useMemo, useState } from 'react';
import { useReference } from '@/lib/queries';
import { t } from '@/lib/i18n';
import { Input, Select } from './ui';

/** Searchable IANA time-zone picker (never fixed offsets). */
export function TimeZoneSelect({ value, onChange, invalid, id }: { value: string; onChange: (v: string) => void; invalid?: boolean; id?: string }) {
  const ref = useReference();
  const [filter, setFilter] = useState('');
  const zones = useMemo(() => {
    const all = ref.data?.timeZones ?? [];
    const f = filter.trim().toLowerCase().replace(/\s+/g, '_');
    const list = f ? all.filter((z) => z.zone.toLowerCase().includes(f)) : all;
    // Keep the selected value visible even when filtered out.
    if (value && !list.some((z) => z.zone === value)) {
      const cur = all.find((z) => z.zone === value);
      if (cur) return [cur, ...list];
    }
    return list;
  }, [ref.data, filter, value]);
  return (
    <div className="flex gap-2">
      <Input placeholder={t('Filter… e.g. Beirut')} value={filter} onChange={(e) => setFilter(e.target.value)} className="w-36 shrink-0" aria-label={t('Filter time zones')} />
      <Select id={id} value={value} onChange={(e) => onChange(e.target.value)} invalid={invalid} className="min-w-0 flex-1">
        <option value="">{t('Select time zone…')}</option>
        {zones.map((z) => (
          <option key={z.zone} value={z.zone}>
            {z.zone.replace(/_/g, ' ')} ({z.offset})
          </option>
        ))}
      </Select>
    </div>
  );
}
